import moment from "moment";
import { Moment } from "moment";

const dateTimeFormatOptions: Intl.DateTimeFormatOptions = { 
    year: "numeric", 
    month: "numeric", 
    day: "numeric", 
    hour: "numeric", 
    minute: "numeric", 
    second: "numeric", 
    hour12: false, 
    timeZone: "America/Chicago" 
};
export function convertToCentralTime(date: Date): Date {
    return new Date(Intl.DateTimeFormat("en", dateTimeFormatOptions).format(date));
}

export function isTimeBetween(nowTime: Moment, start: string = "00:00", end: string = "23:59"): boolean {
    const time = nowTime.format("HH:mm");
    return start <= time && time <= end;
}

export function isDateBetween(nowTime: Date, start: Date, end: Date): boolean {
    return moment(start).isBefore(nowTime) && moment(end).isAfter(nowTime);
}